import React, { useState, useContext, useRef } from 'react'
import Grid from '@material-ui/core/Grid'
import { Field } from 'react-final-form'
import { useLocation } from 'react-router-dom'
import {
  List,
  Filter,
  TextField,
  useListRepository,
  useFilter,
  AuthContext,
  DatePicker,
  Snackbar
} from 'elentari'
import abbreviate from 'abbreviate-name'
import SolicitacoesRepository from './SolicitacoesRepository'
import { useAbility } from '../Usuarios'
import { getListActions } from '../../lib/crudAuthorization'
import moment from 'moment'
import UsuarioAutocomplete from '../Usuarios/UsuarioAutocomplete'
import { BadgeStatus, BadgeFonteLiberacao, StatusEnum } from './components'
import CentroCustoAutocomplete from '../CentrosCusto/CentroCustoAutocomplete'
import { CustomAutocomplete } from '../../components'
import MercadoriaAutocomplete from '../Mercadorias/MercadoriaAutocomplete'
import { parseCpf } from '../../utils/Parse'
import * as R from 'ramda'
import EmpresaSelect from '../Empresa/EmpresaSelect'
import UnidadeNegocioAutocomplete from '../UnidadeNegocio/UnidadeNegocioAutocomplete'
import InfoIcon from '@material-ui/icons/Info'
import { makeStyles, Tooltip, Typography } from '@material-ui/core'
import relatoriosRepository from '../Relatorios/RelatoriosRepository'
import {
  formatAnaliseDocumentos,
  formatSolicitacaoFilterInitialValues
} from '../../utils/Formatter'
import {
  fonteLiberacaoOptions,
  solicitacoesAnaliseDeDocumentosOptions
} from '../../utils/Options'

const useStyles = makeStyles(() => ({
  info: {
    display: 'flex',
    justifyContent: 'space-between'
  }
}))

const SolicitacoesFilter = () => {
  const classes = useStyles()
  const { user } = useContext(AuthContext)
  const { initialValues, onClear, onSubmit } = useFilter({})
  const isGestor = user.realm === 'gestor'
  const statusList = useRef(Object.values(StatusEnum).map(status => ({
    label: status,
    value: status
  })))
  
  const detailedFilter = () => (
    <Grid container spacing={2}>
      <Grid item xs={12} md={3}>
        <Field
          fullWidth
          component={DatePicker}
          label="Data Criação De"
          name="createdAt"
        />
      </Grid>
      <Grid item xs={12} md={3}>
        <Field
          fullWidth
          component={DatePicker}
          label="Data Criação Até"
          name="createdAtFim"
        />
      </Grid>
      <Grid item xs={12} md={3}>
        <Field
          fullWidth
          component={DatePicker}
          label="Data Término De"
          name="dataTermino"
        />
      </Grid>
      <Grid item xs={12} md={3}>
        <Field
          fullWidth
          component={DatePicker}
          label="Data Término Até"
          name="dataTerminoFim"
        />
      </Grid>
      <Grid item md={isGestor ? 6 : 4} xs={12}>
        <EmpresaSelect />
      </Grid>
      <Grid item md={isGestor ? 6 : 4} xs={12}>
        <Field
          fullWidth
          name="unidadeNegocioId"
          label="Unidades de negócio"
          component={UnidadeNegocioAutocomplete}
        />
      </Grid>
      {!isGestor && (
        <Grid item md={4} xs={12}>
          <Field
            fullWidth
            name="centroCustoId"
            label="Centro de custo"
            component={CentroCustoAutocomplete}
          />
        </Grid>
      )}
    </Grid>
  )

  return (
    <Filter
      onSubmit={onSubmit}
      onClear={onClear}
      initialValues={formatSolicitacaoFilterInitialValues(initialValues)}
      detailedFilter={detailedFilter()}
      labels={{
        detailedFilter: 'Busca avançada',
        simpleFilter: 'Busca simples',
        find: 'Buscar',
        clear: 'Limpar'
      }}
    >
      <Grid spacing={3} container>
        <Grid className={classes.info} item xs={12}>
          <Typography variant="h6">Filtros</Typography>
          <Tooltip title="Os filtros irão considerar registros dos últimos 7 dias">
            <InfoIcon />
          </Tooltip>
        </Grid>
        <Grid item md={4} xs={12}>
          <Field
            fullWidth
            name="motorista"
            label="Motorista"
            component={TextField}
          />
        </Grid>
        <Grid item md={4} xs={12}>
          <Field
            fullWidth
            name="cpf"
            label="CPF Motorista"
            parse={parseCpf}
            component={TextField}
          />
        </Grid>
        <Grid item md={4} xs={12}>
          <Field
            fullWidth
            name="responsavelId"
            label="Responsável"
            component={UsuarioAutocomplete}
            realm="analistaadmin"
          />
        </Grid>
        <Grid item md={4} xs={12}>
          <Grid container spacing={2}>
            <Grid item md xs={12}>
              <Field
                fullWidth
                options={solicitacoesAnaliseDeDocumentosOptions}
                name="analiseDocumentos"
                label="Análise de Documentos"
                component={CustomAutocomplete}
              />
            </Grid>
            <Grid item md xs={12}>
              <Field
                fullWidth
                name="placa"
                label="Placa"
                component={TextField}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item md={4} xs={12}>
          <Field
            fullWidth
            name="nomeEmbarcador"
            label="Embarcador"
            component={TextField}
          />
        </Grid>

        <Grid item md={4} xs={12}>
          <Field
            fullWidth
            name="mercadoriaId"
            label="Mercadoria"
            component={MercadoriaAutocomplete}
          />
        </Grid>
        <Grid item md={isGestor ? 4 : 6} xs={12}>
          <Grid container spacing={2}>
            {!isGestor && (
              <Grid item md xs={12}>
                <Field
                  fullWidth
                  options={[
                    { label: 'Sim', value: true },
                    { label: 'Não', value: false }
                  ]}
                  name="exclusivaanalista2"
                  label="Exclusiva analista 2"
                  component={CustomAutocomplete}
                />
              </Grid>
            )}
            <Grid item md xs={12}>
              <Field
                fullWidth
                options={[
                  { label: 'Sim', value: true },
                  { label: 'Não', value: false }
                ]}
                name="renovado"
                label="Renovação"
                component={CustomAutocomplete}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item md={isGestor ? 8 : 6} xs={12}>
          <Grid container spacing={2}>
            <Grid item md xs={12}>
              <Field
                fullWidth
                options={statusList.current}
                name="status"
                label="Status"
                component={CustomAutocomplete}
              />
            </Grid>
            <Grid item md xs={12}>
              <Field
                fullWidth
                options={fonteLiberacaoOptions}
                name="fonteLiberacao"
                label="Fonte de Liberação"
                component={CustomAutocomplete}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Filter>
  )
}

const Solicitacoes = ({ history, ...props }) => {
  const [ability] = useAbility()
  const location = useLocation()
  const [mensagem, setMensagem] = useState('')

  const listOptions = {
    defaultOrder: 'createdat desc',
    fields: {
      id: {
        label: 'Id'
      },
      motorista: {
        label: 'Motorista',
        format: motorista => (motorista ? abbreviate(motorista.nome) : '-'),
        noOrder: true,
        align: 'center'
      },
      createdat: {
        label: 'Data Criação',
        format: data => moment(data).format('DD/MM/YYYY HH:mm'),
        align: 'center'
      },
      status: {
        label: 'Status',
        format: (value, solicitacao) => (
          <BadgeStatus
            status={value}
            fonteLiberacao={solicitacao.fonteLiberacao}
            cenario={solicitacao.cenario}
          />
        ),
        align: 'center'
      },
      datatermino: {
        label: 'Data Término',
        format: data => (data ? moment(data).format('DD/MM/YYYY HH:mm') : '-'),
        align: 'center'
      },
      mercadoria: {
        label: 'Mercadoria',
        format: mercadoria => (mercadoria ? mercadoria.descricao : '-'),
        noOrder: true,
        align: 'center'
      },
      nomeEmbarcador: {
        label: 'Embarcador',
        format: value => (value ? abbreviate(value) : ''),
        noOrder: true,
        align: 'center'
      },
      centroCusto: {
        label: 'Centro de Custo',
        format: centroCusto => (centroCusto ? centroCusto.descricao : '-'),
        noOrder: true,
        align: 'center'
      },
      responsavel: {
        label: 'Responsável',
        format: responsavel => (responsavel ? responsavel.nome : '-'),
        noOrder: true,
        align: 'center'
      },
      analiseDocumentos: {
        label: 'Tipo',
        format: formatAnaliseDocumentos
      },
      fonteliberacao: {
        label: 'Fonte de Liberação',
        format: fonteLiberacao => (
          <BadgeFonteLiberacao fonteLiberacao={fonteLiberacao} />
        ),
        align: 'center'
      }
    }
  }

  const listHook = useListRepository({
    repository: SolicitacoesRepository,
    path: 'solicitacoes',
    defaultSort: 'createdat desc',
    cancelPreviousRequest: true
  })
  const actions = getListActions(ability, listHook, 'solicitacoes')

  const onDownloadClick = async () => {
    setMensagem('Preparando a criação do relatório')
    const params = new URLSearchParams(location.search)
    const { page, rows, sort = 'createdat desc', ...allQuery } = R.fromPairs([
      ...params.entries()
    ])
    const response = await relatoriosRepository.criarRelatorioSolicitacoes({
      paginate: {
        include: 'veiculos'
      },
      query: {
        ...allQuery,
        ...(sort ? { sort } : {})
      }
    })
    if (!response.ok) {
      setMensagem(
        response.data.error.message || 'Falha na criação do relatório'
      )
    } else {
      setTimeout(() => {
        setMensagem(
          'O Download será liberado na página de Relatórios assim que ficar pronto, qualquer problema entre em contato com o suporte!'
        )
      }, 2000)
    }
  }

  return (
    <>
      <SolicitacoesFilter />
      <List
        {...props}
        {...listHook}
        {...actions}
        stickyHeader
        adjustToScreenHeight
        onClickView={null}
        onClickNew={null}
        onClickEdit={null}
        removeItem={null}
        flatOnDownload
        csvSeparator=";"
        onDownloadClick={onDownloadClick}
        onClickRow={item =>
          history.push(`/solicitacoes/${item.id}${history.location.search}`)
        }
        listOptions={listOptions}
      />
      <Snackbar message={mensagem} onClose={() => setMensagem('')} />
    </>
  )
}

export default Solicitacoes
